<script lang="ts">
    import { faUser, type IconDefinition } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import { Link, navigateTo, router } from 'yrv'

    export let tabs: {
        title?: string
        url?: string | any
        icon?: IconDefinition
        spacer?: boolean
        appearence?: 'tab' | 'link'
    }[] = []
    export let active = null
    export let color: string = null
    export let full: boolean = false
    export { className as class }
    let className = ''

    function go(ev, url: any) {
        ev.preventDefault()
        if (typeof url === 'function') {
            url()
        } else {
            navigateTo(url)
        }
    }

    let current = ''
    router.subscribe((e) => {
        current = location.pathname
        tabs = tabs
    })

    function linkIsActive(url, title) {
        if ((active && active === title) || (!active && current.includes(url))) {
            if (!color) return ';' // !!!!!
            return 'background-color:' + color + ';text-shadow:2px 2px 2px #333333ff;'
        }
        return ''
    }
</script>

<div class="ztab {className}" style="{color ? 'border-bottom-color:' + color : ''};">
    <div class="inside" class:ztab_inner={!full}>
        {#each tabs as tab}
            {#if tab.spacer}
                <div class="ztab_spacer"></div>
            {:else if tab.appearence === 'link'}
                <a class="ztab_link" href={null} on:click={(ev) => go(ev, tab.url)}>
                    {#if tab.icon}
                        <Fa class="ztab_icon" icon={tab.icon} />
                    {/if}
                    {tab.title}
                </a>
            {:else}
                <a
                    class="ztab_tab ztab_tab_is-active_{!!linkIsActive(tab.url, tab.title)}"
                    style={linkIsActive(tab.url, tab.title)}
                    href={tab.url}
                    on:click={(ev) => go(ev, tab.url)}
                >
                    {#if tab.icon}
                        <Fa class="ztab_icon" icon={tab.icon} />
                    {/if}
                    {tab.title}
                </a>
            {/if}
        {/each}
    </div>
</div>

<style>
</style>
